import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialSubmitRegistrationCacheKeys } from "./constants";
import type { SubmitDataPayload } from "./types";

export const submitRegistrationData = reactQueryMutationAdapter(
  freeTrialSubmitRegistrationCacheKeys,
  async (payload: SubmitDataPayload): Promise<any> => {
    return fetch(`/free_trial/submit_registration`, "POST", payload, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
